import React from 'react';

import { Layout } from 'components/Layout';
import { StrapiArticle, StrapiCategory, StrapiResponse } from 'types/strapiService/types';
import { MagazineArticle } from 'components/MagazineArticle';
import { getStrapiImageUrl } from 'lib/strapi/getStrapiImageUrl';
import { Paginate } from 'components/Paginate';
import { Gutter } from 'components/Gutter';
import { Banner } from 'components/Banner';

import styles from './Category.module.scss';

interface Props {
  articles: StrapiResponse<StrapiArticle[]> | null;
  category: StrapiCategory;
  mostPopularArticles: StrapiArticle[] | null;
}

export const Category: React.FC<Props> = ({ articles, category, mostPopularArticles }) => {
  const articleList = articles?.data || [];
  const pagination = articles?.meta.pagination;

  return (
    <Layout>
      <div className={styles.container}>
        <h1>{category.attributes.name}</h1>
        <div className={styles.wrapper}>
          <main>
            <h2>Senaste artiklar</h2>

            {articleList.map((article) => {
              const image = article.attributes.seo.shareImage.data?.attributes.url;
              return (
                <MagazineArticle
                  // @ts-ignore
                  category={article.attributes.categories.data[0].attributes.name ?? ''}
                  key={article.id}
                  date={article.attributes.publishedAt}
                  title={article.attributes.seo.metaTitle}
                  text={article.attributes.seo.metaDescription}
                  imageSrc={image && getStrapiImageUrl(image)}
                  // @ts-ignore
                  href={`/${article.attributes.categories.data[0].attributes.slug}/${article.attributes.url}`}
                />
              );
            })}
            {pagination ? (
              <div className={styles['paginate-wrapper']}>
                <Paginate
                  itemsTotal={pagination.total}
                  itemsPerPage={10}
                  pathname="/magazine"
                  currentPage={pagination.page}
                />
              </div>
            ) : null}
          </main>

          <aside>
            <h2>Utvalda artiklar </h2>

            {mostPopularArticles &&
              mostPopularArticles.map((article) => (
                <MagazineArticle
                  variant="small"
                  // @ts-ignore
                  category={article.attributes.categories.data[0].attributes.name ?? ''}
                  key={article.id}
                  date={article.attributes.publishedAt}
                  title={article.attributes.seo.metaTitle}
                  text={article.attributes.seo.metaDescription}
                  imageSrc={getStrapiImageUrl(
                    article.attributes.seo.shareImage.data.attributes.url
                  )}
                  // @ts-ignore
                  href={`/${article.attributes.categories.data[0].attributes.slug}/${article.attributes.url}`}
                />
              ))}
          </aside>
        </div>
      </div>
      <Gutter>
        <Banner
          headline="Företagare med hög leasingkostnad?"
          content="Med Blipp kan du lägga om ditt nuvarande leasingavtal på din företagsbil och se över dina kostnader.
Skicka in din ansökan så återkommer vi med ett förslag på en ny leasing."
          link="/foretag/release"
        />
      </Gutter>
    </Layout>
  );
};
